export const prices=[
    {basic:"4,000",  premium:"14,300"},
    {basic:"19,500",  premium:"65,000"},
    {basic:"78,500", premium:"234,000"}
  ]